<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2>
        {{ 'unexpected_error.title' | translate }}
    </h2>
    <section class="infoBox">
        <p>{{'unexpected_error.infoBox.1' | translate }}</p>
    </section>
</main>
